/**************************************************
 * Nombre:       Tarjeta_Caracteristicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Unica = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderRadius: 1,
                border: 0.5,
                borderColor: '#ffffff50',
                background: 'linear-gradient(151deg, rgba(255, 255, 255, 0.10) 6.5%, rgba(45, 45, 45, 0.10) 59.48%)',
                backdropFilter: 'blur(5px)',
                color: '#fff',
                p: 3
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{fontSize: 20, fontWeight: 600, textAlign: 'left'}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 15, fontWeight: 400, textAlign: 'left'}}>
                    {item.descripcion}
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Unica